import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { INVOICE_STATUS_LABELS, INVOICE_TYPE_LABELS } from "../../constants/labels"
import { useGetVendorName } from "../../hooks/useGetVendorName"
import type { InvoicesSearchParams } from "../../schemas"

import { FilterChip } from "@/components/common/Filters"

interface InvoicesFilterChipsProps {
  searchParams: InvoicesSearchParams
  onRemove: (key: keyof InvoicesSearchParams, value?: string | number) => void
}

export const InvoicesFilterChips: FC<InvoicesFilterChipsProps> = ({ searchParams, onRemove }) => {
  const statuses = searchParams.statuses ?? []
  const { invoiceType, vendorCompanyId } = searchParams

  const { vendorName } = useGetVendorName(vendorCompanyId)

  const hasActiveFilters = statuses.length > 0 || !!invoiceType || !!vendorCompanyId

  if (!hasActiveFilters) return null

  return (
    <Box data-testid='invoices.filter-chips' className='flex flex-wrap items-center gap-4'>
      <Typography variant='body1'>Filters:</Typography>

      {statuses.map((status) => {
        const statusTestId = `invoices.filter-chips.status-${status.toLowerCase().replace(/_/g, "-")}`
        return (
          <FilterChip
            key={statusTestId}
            testId={statusTestId}
            label={`Status: ${INVOICE_STATUS_LABELS[status]}`}
            onDelete={() => onRemove("statuses", status)}
          />
        )
      })}

      {invoiceType && (
        <FilterChip
          key='invoices.filter-chips.invoice-type'
          testId='invoices.filter-chips.invoice-type'
          label={`Transaction Type: ${INVOICE_TYPE_LABELS[invoiceType]}`}
          onDelete={() => onRemove("invoiceType")}
        />
      )}

      {vendorCompanyId && (
        <FilterChip
          key='invoices.filter-chips.vendor'
          testId='invoices.filter-chips.vendor'
          label={vendorName ? `Vendor: ${vendorName}` : "Vendor"}
          onDelete={() => onRemove("vendorCompanyId")}
        />
      )}
    </Box>
  )
}
